import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Api } from './api.service';

@Injectable({providedIn: 'root'})
export class QuickBooksService extends Api {
  controllerName = 'api/quickbooks';

  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  getConnectUrl(redirectUrl: string) {
    return `${environment.apiUrl}/${this.controllerName}/connect?redirectUrl=${redirectUrl}`;
  }

}
